import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TextsTodo } from 'projects/speaker-platform/src/app/types/texts-todo.enum';

@Component({
  selector: 'app-texts-menu',
  imports: [RouterModule],
  templateUrl: './texts-menu.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./texts-menu.component.scss']
})
export class TextsMenuComponent {
  @Input() todo: TextsTodo = TextsTodo.RECORD;
  textsTodo = TextsTodo;
}
